var apiRoutes = {
    APPROVAL_QUEUE: '/api/account/approval-queue',
    CHANGE_PASSWORD: '/api/account/change-password',
    CUSTOMER_SEARCH: '/api/customer/search',
    DISTRIBUTOR_SEARCH: '/api/distributor/search',
    FORGOT_PASSWORD: '/api/account/forgot-password',
    GET_CUSTOMER: '/api/customer/',
    GET_DISTRIBUTOR: '/api/distributor/',
    GET_OEM: '/api/oem/',
    GET_SECURITY: '/api/account/get-security',
    HEARTBEAT_GET: '/api/heartbeat',
    OEM_SEARCH: '/api/oem/search',
    REGISTER: '/api/account/sign-up',
    REPORT_ACCESS: '/api/reports/record-access',
    REPORT_DATA_BASE: '/api/reports/get-data/',
    REPORT_EXPORT_ALL: '/api/reports/export-all',
    REPORT_EXPORT: '/api/reports/export?limit=20',
    REPORT_PDF_BASE: '/api/reports/',
    REPORT_SEARCH: '/api/reports/search',
    RESET_PASSWORD: '/api/account/reset-password',
    SAMPLE_SEARCH: '/api/sample/search',
    SET_SECURITY: '/api/account/set-security',
    TOKEN: '/api/token',
    USER_APPROVE: '/api/account/approve',
    USER_REJECT: '/api/account/deny',
    USER_RESTORE_ACCESS: '/api/account/grant-access',
    USER_REVOKE_ACCESS: '/api/account/revoke-access',
    USER_REVOKED_SEARCH: '/api/account/search',
    USER_SEARCH: '/api/account/search',
    VERIFY: '/api/account/verify'
}

export default apiRoutes;



// WEBPACK FOOTER //
// ./web-app/constants/api-routes.js